import { render } from "./DemandTemplateTable.vue?vue&type=template&id=16b268aa"
import script from "./DemandTemplateTable.vue?vue&type=script&lang=ts"
export * from "./DemandTemplateTable.vue?vue&type=script&lang=ts"
script.render = render

export default script